exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "input[type=\"color\"] {\n  -webkit-appearance: none;\n  border: none;\n  width: 100px;\n  height: 32px; }\n\ninput[type=\"color\"]::-webkit-color-swatch-wrapper {\n  padding: 0; }\n\ninput[type=\"color\"]::-webkit-color-swatch {\n  border: none; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /app/src/app/components/endereco-components/componente/adicionar-componente/adicionar-componente.component.scss
// module id = ../../../../../src/app/components/endereco-components/componente/adicionar-componente/adicionar-componente.component.scss
// module chunks = main